// @flow
import type { SagaIterator } from 'redux-saga';
import { put } from 'redux-saga/effects';
import { call as typedCall } from 'typed-redux-saga';

import { apiFetch } from './ApiSaga';
import { setSagaMessage } from '../Redux/ApplicationActions';
import api from '../Services/Api';
import { finishLoading, startLoading } from '../Redux/LoadingActions';
import { receiveNotifiableEventGroup } from '../Redux/NotificationActions';
import type { GetNotifiableEventGroup } from '../Redux/NotificationActions';
import type { ApiGetNotifiableEventGroupResponse } from '../Utils/apiTypes';
import { ResourceErrorInterface } from 'tg-resources';

export function* getNotifiableEventGroupSaga(action: GetNotifiableEventGroup): SagaIterator<void> {
  const { notifiableGroupId } = action;

  yield put(startLoading('notifiableEventGroup'));

  const { result, error } = yield* typedCall(
    apiFetch<ApiGetNotifiableEventGroupResponse>,
    api.txp.notifiableEventGroup,
    {
      notifiableGroupId,
    },
  );

  if (error || !result) {
    if (error instanceof ResourceErrorInterface) {
      if (error.isValidationError) {
        const errorMessage = error;
        yield put(setSagaMessage('', `${errorMessage}`, ''));
      } else if (error.isNetworkError) {
        yield put(setSagaMessage('Loading events failed', 'Are you online?', ''));
      } else {
        yield put(setSagaMessage('Loading events failed', 'Try again later', ''));
      }
    }
  } else {
    const events = result.notifiable_events;

    const notifiableEvents = [];
    for (let i = 0; i < events.length; i += 1) {
      notifiableEvents.push({
        notifiableEventId: events[i].notifiable_event_id,
        eventDescription: events[i].event_description,
        sequence: events[i].sequence_position,
        eventType: events[i].event_type,
        targetType: events[i].target_type,
        subtargetType: events[i].subtarget_type,
        subtargetId: events[i].subtarget_id,
      });
    }
    notifiableEvents.sort((a, b) => a.sequence - b.sequence);

    yield put(receiveNotifiableEventGroup(notifiableEvents));

    yield put(finishLoading('notifiableEventGroup'));
  }
}
